import { general_sv } from "./sv/general_sv";
import { myPage_sv } from "./sv/myPage_sv";
import { createWalks_sv } from "./sv/createWalk_sv";
import { findWalks_sv } from "./sv/findWalks_sv";
import { logIn_sv } from "./sv/logIn_sv";
import { chat_sv } from "./sv/chat_sv";
import { walk_sv } from "./sv/walk_sv";
import { stepCounter_sv } from "./sv/stepCounter_sv";
import { templates_sv } from "./sv/templates_sv"
import { purchase_sv } from "./sv/purchase_sv"
import { newCreate_sv } from "./sv/newCreate_sv"

export const language_sv = {
  'language_page': 'Språksidan',
  'change_language': 'Byt språk',
  ...general_sv,
  ...myPage_sv,
  ...createWalks_sv,
  ...findWalks_sv,
  ...logIn_sv,
  ...chat_sv,
  ...walk_sv,
  ...stepCounter_sv,
  ...templates_sv,
  ...purchase_sv,
  ...newCreate_sv
}
